import React from "react";
import T from "prop-types";
import { toggleSwitch } from "MODULES/shared/decorators";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import NotCompletelyShippedWarning from "../NotCompletelyShippedWarning";

export function RmaRequest({ lineItem, warningOpen, close, openRma, open }) {
  const completelyShipped = lineItem.quantity === lineItem.quantity_shipped;
  const onClick = completelyShipped ? () => openRma(lineItem) : open;

  return (
    <DropDownItem onClick={onClick}>
      <i className="fa fa-fw fa-cog" />
      &nbsp;Customer RMA Request
      <NotCompletelyShippedWarning warningOpen={warningOpen} close={close} />
    </DropDownItem>
  );
}

RmaRequest.propTypes = {
  lineItem: T.shape({}),
  openRma: T.func.isRequired,
  warningOpen: T.func.isRequired,
  open: T.func.isRequired,
  close: T.func.isRequired
};

export default toggleSwitch("warningOpen")(RmaRequest);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/RmaRequest/RmaRequest.jsx